module.exports = __webpack_public_path__ + "static/img/background-4.57b5389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-4.jpg
// module id = TFwq
// module chunks = 0